import { Controller } from "@hotwired/stimulus"
import consumer from '@channels/consumer'
import { useIdle, useVisibility } from 'stimulus-use'

// Connects to data-controller="record-presence"
export default class extends Controller {
  
  static targets = ["list"]
  static values = { id: String }

  initialize() {
    this.ACTIVITY_EVENTS = ["mousemove", "mousedown", "keydown", "resize", "wheel", "touchstart"]
    this.debug = true
    this.status = "online"
  }
  
  connect() {

    useIdle(this, { ms: 60_000 })
    useVisibility(this)

    // Store the controller instance
    const controller = this

    // Set up the consumer connection
    this.channel = consumer.subscriptions.create({ channel: "RecordPresenceChannel", id: controller.idValue }, {

      initialized() {
        controller.debug && console.log(`${controller.idValue}: initialized`)
      },

      connected() {
        controller.debug && console.log(`${controller.idValue}: connected`)
        this.perform(document.hidden ? "away" : "active")
      },

      disconnected() {
        controller.debug && console.log(`${controller.idValue}: disconnected`)
      },

      received(data) {
        // console.log(`${controller.idValue}: event received`, data.type, data.user.name, data)
        if (data.type == "user-subscribe") controller.handleSubscribe(data)
        if (data.type == "user-active") controller.setUser(data.user, "online")
        if (data.type == "user-idle") controller.setUser(data.user, "idle")
        if (data.type == "user-away") controller.setUser(data.user, "away")
        if (data.type == "user-announce") controller.setUser(data.user, data.status)
        if (data.type == "user-unsubscribe") controller.removeUser(data.user)
      }
      
    })
    
  }

  disconnect() {
    this.channel?.unsubscribe()
  }

  get currentUser() {
    return JSON.parse(document.body.dataset.user)
  }

  handleSubscribe(data) {
    this.setUser(data.user)
    this.channel?.perform("announce", { status: this.status })
  }
  
  // Event handlers from useIdle and useVisibility
  away() {
    if (document.hidden) return
    this.channel?.perform("idle")
    this.status = "idle"
  }

  back() {
    this.channel?.perform("active")
    this.status = "online"
  }

  visible() {
    this.channel?.perform("active")
    this.status = "online"
  }

  invisible() {
    this.channel?.perform("away")
    this.status = "away"
  }
  

  // Methods
  setUser(user, status = "online") {
    
    const color = user.color || "gray-200"
    const statusText = status === "online" ? "En ligne" : status === "idle" ? "Inactif" : "Absent"
    
    let avatar = this.listTarget.querySelector(`[data-id="${user.id}"]`)
    
    // If we already have an avatar for this user, update the status
    if (avatar) {
      avatar.classList.remove("online", "idle", "away")
      avatar.classList.add(status)
    } 
    
    // Else create a new avatar and insert it
    else {
      avatar = `
        <div class="avatar ${status} bg-${color}" data-id="${user.id}" title="${user.name}: ${statusText}">
          ${user.initials}
        </div>`
      this.listTarget.innerHTML += avatar
    }
  }

  removeUser(user) {
    const avatar = this.listTarget.querySelector(`[data-id="${user.id}"]`)
    avatar?.remove()
  }
    
}
